var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 63,
    viewBox: "0 0 38 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 63,
    viewBox: "0 0 38 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_792_1388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30908 36.0666L20.4541 25.9734L23.9633 23.0661L22.6473 36.0666H8.30908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30908 36.0666H22.6473L20.0977 46.5163L8.30908 36.0666Z",
    fill: "#D5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0977 46.5163L22.6473 36.0666L30.6252 36.3409L20.0977 46.5163Z",
    fill: "#86CCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6473 36.0666L23.9633 23.0661L30.6252 36.3408L22.6473 36.0666Z",
    fill: "#D5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9423 16.4836L23.9632 23.0661L30.6252 36.3409L27.2531 20.2137L12.9423 16.4836Z",
    fill: "#08445E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9423 16.4836L8.30908 36.0666L20.4541 25.9734L12.9423 16.4836Z",
    fill: "#1B9AB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9423 16.4836L1.2085 26.4122L8.3091 36.0666L12.9423 16.4836Z",
    fill: "#86CCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2085 26.4122L7.26731 42.5119L8.3091 36.0666L1.2085 26.4122Z",
    fill: "#D5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26727 42.512L20.0977 46.5163L8.30906 36.0666L7.26727 42.512Z",
    fill: "#86CCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9423 16.4836L23.9633 23.0661L20.4541 25.9734L12.9423 16.4836Z",
    fill: "#1F8E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0526075 35.6277H-6.90646C-6.71455 36.9442 -5.89209 37.959 -4.24717 37.959C-3.39729 37.959 -2.73932 37.7122 -2.38292 37.1362H-0.271936C-0.820244 38.727 -2.38292 39.6321 -4.27458 39.6321C-7.01612 39.6321 -8.88037 37.6299 -8.88037 35.0518C-8.88037 32.4736 -7.04354 30.4714 -4.38425 30.4714C-1.47821 30.444 0.331208 32.6656 -0.0526075 35.6277ZM-6.85163 34.2838H-1.94427C-2.05393 32.8576 -2.98606 32.0896 -4.32941 32.0896C-5.80984 32.0896 -6.63231 33.0496 -6.85163 34.2838Z",
    fill: "#08445E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_792_1388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 63,
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06ab139bd2fa0039a9d97a5b1a39f9fe.svg";
export { ForwardRef as ReactComponent };